import { Client } from "../Firestore/Client";

export const buildClientProfileSettings = (client) => ({
  name_for_coach: client.nameForCoach ?? "",
  surname_for_coach: client.surnameForCoach ?? "",
  notes: client.notes ?? "",
  phone: client.phone ?? "",
  gender: client.gender ?? false,
  profile_squat: client.profileSquat ?? 0,
  profile_bench_press: client.profileBenchPress ?? 0,
  profile_deadlift: client.profileDeadlift ?? 0,
  dietary_preference: client.dietaryPreference ?? "none",
  allergen_codes: client.allergenCodes ?? [],
  show_nutrition_plan_totals_override:
    client.showNutritionPlanTotalsOverride,
});

export const buildActiveClientFromUserData = ({
  coach,
  userData,
  blockTotalWeeks,
  blockWeeks,
  blockName,
}) => {
  const client = new Client(
    userData.user_id,
    userData.email,
    userData.user_name ?? "New Client",
    userData.user_surname ?? "",
    userData.name_for_coach ?? userData.user_name ?? "New Client",
    userData.surname_for_coach ?? userData.user_surname ?? "",
    userData.bodyweight_unit,
    userData.exercise_unit,
    userData.last_backup,
    userData.rir_or_rpe,
    userData.language,
    userData.exercises_metrics_pinned,
    userData.is_checked,
    blockTotalWeeks,
    blockWeeks,
    coach,
    userData.week_workouts ?? [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    userData.phone ?? "",
    userData.notes,
    undefined,
    undefined,
    userData.fee_history ?? [],
    userData.gender,
    blockName,
    userData.weekly_form_id ?? "",
    userData.block_form_id ?? "",
    userData.profile_squat ?? 0,
    userData.profile_bench_press ?? 0,
    userData.profile_deadlift ?? 0,
    userData.dietary_preference ?? "none",
    userData.allergen_codes ?? [],
    "",
    false,
    "",
    null,
    userData.show_nutrition_plan_totals_override
  );

  client.clientSettings = buildClientProfileSettings(client);
  client.clientSettingsBaseline = buildClientProfileSettings(client);

  return client;
};
